import { gql } from '@apollo/client';

export const SEARCH_DIRECTORIES_WITH_FILES_QUERY = gql`
  query searchDirectoriesWithFiles(
    $directoryTypeId: Int
    $projectId: String
    $sorting: ESorting
    $status: EDirectoryStatus
    $tag: String
    $title: String
  ) {
    directory {
      searchDirectories(
        directoryTypeId: $directoryTypeId
        projectId: $projectId
        sorting: $sorting
        status: $status
        tag: $tag
        title: $title
      ) {
        asset {
          contentType
          presignedUrl
          s3Key
        }
        description
        directoryType {
          id
          name
        }
        email
        files {
          asset {
            contentType
            fileName
            presignedUrl
            s3Key
          }
        }
        friendlyUrl
        id
        phoneNumber
        status
        subTitle
        linkedTags {
          id
          name
          sort
        }
        title
        url
      }
    }
  }
`;
